import Header from "../../app/universalComponents/Header";
import Footer from "../../app/universalComponents/Footer";
import { Link } from "react-router-dom";

export default function NotFoundPage() {
    return (
        <div className="min-h-screen flex flex-col">
            <Header sellTickets={true} />

            <main className="flex flex-1 items-center justify-center px-6 py-20">
                <section className="max-w-xl text-center">
                    <p className="text-xs font-semibold uppercase tracking-widest text-gray-500">
                        Page not found
                    </p>

                    <h1 className="mt-4 text-7xl font-black tracking-tight text-black lg:text-9xl">
                        404
                    </h1>

                    <hr className="mx-auto my-6 h-px w-24 bg-gray-300" />

                    <h2 className="text-4xl lg:text-5xl font-bold">
                        This page doesn’t exist
                    </h2>

                    <p className="mt-4">
                        The event you’re looking for may have passed
                        or the link might be incorrect.
                    </p>

                    <button className="mt-8 mx-auto items-center justify-center rounded-sm bg-black py-2 px-4 text-lg text-white transition hover:opacity-75">
                        <Link to="/">
                            Go back home
                        </Link>
                    </button>
                </section>
            </main>

            <Footer />
        </div>
    );
}